import React, { useState, useEffect } from "react";
import { Box, Divider } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Page from "../../../../../components/Page";
import Header from "./Header";
import { useDispatch } from "react-redux";
import {
  getRolesAndAccess,
  updateRolesAndAccess,
} from "../../../../../core/repo/accountRepo";
import Loader from "../../../../../components/Loader";
import Results from "./Results";

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 8,
    background: theme.palette.background.dark,
  },
  container: {
    borderRadius: 24,
    border: `1px solid ${theme.palette.divider}`,
    width: "100%",
    height: "100%",
    background: theme.palette.background.default,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
}));

function RoleAccess() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);
  const [editedRoles, setEditedRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

  const fetchRoleAccess = async () => {
    try {
      setIsLoading(true);
      const response = await dispatch(getRolesAndAccess());
      setRoles(response);
      setEditedRoles(response);
    } catch (error) {
      console.error("Error fetching role access:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoleAccess();
  }, []);

  const handleEdit = (id, permission, value) => {
    const updatedRoles = roles.map((role) =>
      role.id === id
        ? {
            ...role,
            permissions: {
              ...role.permissions,
              [permission]: { ...role.permissions[permission], value },
            },
          }
        : role
    );
    setEditedRoles(updatedRoles);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await dispatch(updateRolesAndAccess(editedRoles));
      setRoles(editedRoles);
    } catch (error) {
      console.error("Error saving role access:", error);
    } finally {
      setIsLoading(false);
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setEditedRoles(roles);
    setIsEditing(false);
  };

  const handleClickModify = () => {
    setIsEditing(true);
  };

  const isModified = editedRoles.some(
    (role) =>
      JSON.stringify(role) !==
      JSON.stringify(roles.find((r) => r.id === role.id))
  );

  return (
    <Page title="Users" className={classes.root}>
      <Box className={classes.container} position="relative">
        <Header
          isEditing={isEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleClickModify={handleClickModify}
          isModified={isModified}
        />
        <Divider />
        {isLoading ? (
          <Loader />
        ) : (
          <Box p={3} flex={1} overflow="auto">
            <Results
              roles={isEditing ? editedRoles : roles}
              isEditing={isEditing}
              handleEdit={handleEdit}
            />
          </Box>
        )}
      </Box>
    </Page>
  );
}

export default RoleAccess;
